
import '../App.css';
import '../css/ImageGrid.css'
import { MdOutlineNotifications, MdOutlineCameraAlt } from 'react-icons/md';
import { Tooltip } from "react-tooltip";
import { loginPost } from '../network/login';
import React, { useState, useEffect, useCallback } from 'react';
import { getweeklybest } from '../network/get_weeklybest';
import { gethomebanner } from '../network/get_homebanner';
import { getpopularKeywords } from '../network/get_popularKeywords';
import { getHashtagPosts } from '../network/get_hashtagPosts';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 
import { FaHome, FaSearch,FaSocks,FaIdCard,FaStar, FaUser, FaPoll,FaCamera } from 'react-icons/fa';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router-dom';
import BottomNavBar from '../components/BottomNavBar';
import ImagePopup from '../components/ImagePopup';
import { getPopcodi } from '../network/get_popcodi';
import { LoginRequiredModal } from '../components/loginpopup';
import { ProfileRequiredModal } from '../components/profilepopup';

const KEY_OPTIONS = Array.from({ length: 61 }, (_, i) => 140 + i);


const BASE_URL = 'http://52.79.160.172:8001';
const PAGE_SIZE = 10; // 한 번에 가져올 항목 수

function Home() {

   const [posts, setPosts] = useState([]);
  // 현재 페이지 상태 (다음 요청에 사용될 offset 값)
  const [pageKey, setPageKey] = useState(0);
  // 더 불러올 데이터가 있는지 여부
  const [hasMore, setHasMore] = useState(true);
  // 로딩 상태 (불필요한 중복 요청 방지)
  const [isLoading, setIsLoading] = useState(false);

  const [dailylooksArray, setDailylooksArray] = useState([
  { id: 1, thumbnail: '', user: { gender: 'W' } },
  { id: 2, thumbnail: '', user: { gender: 'M' } }
]);
  const [homebannerArray, setHomebannerArray] = useState([]); 
  const [keywordsArray, setKeywordsArray] = useState([]); 
    const [searchTerm, setSearchTerm] = useState('');

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const [showLoginModal, setShowLoginModal] = useState(false);

    const MAIN_NAV_ITEMS = [
    { name: '홈', iconComponent: FaHome, path: '/' },
    { name: '패션', iconComponent: FaSocks, path: '/fashion_tab' },
    { name: '피드', iconComponent: FaIdCard, path: '/profile' },
        { name: '응모', iconComponent: FaStar, path: '/FaStar' },
            { name: 'MY', iconComponent: FaUser, path: '/profile' },
];


const handleClosePopup = () => {
        setIsPopupOpen(false);
    };

const [currentPath, setCurrentPath] = useState('/'); 
    
    // 페이지 이동(라우팅) 처리 함수
    const handleNavigation = (path) => {
        setCurrentPath(path);
        // 실제 라우팅 로직 (예: navigate(path) 등)
        navigate(path);
        console.log(`페이지 이동: ${path}`);
    };


  const goToPostDetail = (postId, postCategory) => {
    // 쿼리 파라미터 형태로 인자 구성: ?id=123&category=fashion
    const queryParams = new URLSearchParams({
      id: postId,
      category: postCategory
    }).toString();

    // /detail 경로로 인자를 포함하여 GET 방식으로 이동
    navigate(`/dailylook?${queryParams}`);
  };
    
    const goToSearch = (postId, postCategory) => {

                      const savedToken = localStorage.getItem('user');
            const storedUserObject = JSON.parse(savedToken);
            if(storedUserObject.username == 'temp'){
                        setShowLoginModal(true);

            }else{
                  const queryParams = new URLSearchParams({
                id: postId,
                category: postCategory
              }).toString();

              // /detail 경로로 인자를 포함하여 GET 방식으로 이동
              navigate(`/search?${queryParams}`);
            }
    // 쿼리 파라미터 형태로 인자 구성: ?id=123&category=fashion

  };

      const goToAlert = () => {

                const savedToken = localStorage.getItem('user');
            const storedUserObject = JSON.parse(savedToken);
            if(storedUserObject.username == 'temp'){
                        setShowLoginModal(true);

            }else{
                          navigate(`/alert`);
            }
        


  };

  // 2. 입력 값이 변경될 때마다 상태를 업데이트하는 핸들러
  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // 3. 검색 버튼 클릭 또는 Enter 키 입력 시 실행되는 함수
  const handleSearch = () => {
    if (searchTerm.trim() === '') {
      alert('검색어를 입력해 주세요.');
      return;
    }
    // 여기에 실제 검색 API 호출 로직을 넣거나 상위 컴포넌트로 전달합니다.
    console.log(`검색 실행: ${searchTerm}`);
  };

  // 4. Enter 키를 눌렀을 때 검색 함수를 실행하는 핸들러
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };




 
  async function processData() {

    
    const savedToken = localStorage.getItem('user');

    if (savedToken === null) {
      await loginPost("temp", "temp_user")
    // 여기에 로그인 페이지로 리디렉션하는 로직 등을 넣습니다.
    }else{

      const test = await gethomebanner()
      if(test == 'f'){
        localStorage.removeItem('user');
              await loginPost("temp", "temp_user")

      }

              // const storedUserObject = JSON.parse(savedToken);

      }

    const keywordsdata = await getpopularKeywords()
  console.log(keywordsdata)
  const uniqueKeywords = [...new Set(keywordsdata)];
  
  console.log(uniqueKeywords)

  setKeywordsArray(uniqueKeywords.slice(0, 3))

  const dailylookdata = await getweeklybest()
  setDailylooksArray(dailylookdata)
  const homebannerdata = await gethomebanner()
  setHomebannerArray(homebannerdata)

  
}





function StyleTag({ text, isActive, onClick }) {
  // 활성화 상태(isActive)에 따라 스타일을 동적으로 적용할 수 있습니다.
  const tagStyle = styles.defaultTag;
  
  return (
    <button onClick={onClick} style={tagStyle}>
      {/* 텍스트에 밑줄 효과를 주기 위한 스타일 */}
      <span>
        {text}
      </span>
    </button>
  );
}



// ----------------------------------------------------
// 2. 메인 모달 컴포넌트
// ----------------------------------------------------

  const bannerSettings = {
    dots: true, // 하단에 점(dot) 페이지네이션 표시
    arrows: false, // 이전/다음 버튼 숨김
    infinite: true, // 무한 반복
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,

    
  };


    const navigate = useNavigate();

  // 1. 페이지 이동 로직 함수 정의


const fetchPosts = useCallback(async () => {
    // 주의: 함수 내부에서 최신 posts.length를 사용하지 않으므로 posts는 의존성에서 제외
        const savedToken = localStorage.getItem('user');

    if (savedToken === null) {
      await loginPost("temp", "temp_user")
    // 여기에 로그인 페이지로 리디렉션하는 로직 등을 넣습니다.
    }else{

      const test = await gethomebanner()
      if(test == 'f'){
        localStorage.removeItem('user');
              await loginPost("temp", "temp_user")

      }

              // const storedUserObject = JSON.parse(savedToken);

      }


    if (isLoading || !hasMore) return; // 중복 요청 방지

    setIsLoading(true);
    
    try {
      const response = await getPopcodi(
        pageKey, // 최신 pageKey 사용
        PAGE_SIZE,
      );
      
      const newPosts = response.results || [];
      const totalCount = response.total_count;

      // 이전 상태를 기반으로 업데이트해야 정확함
      setPosts(prevPosts => {
          const updatedPosts = [...prevPosts, ...newPosts];
          
          // *주의: posts.length 대신 updatedPosts.length를 사용해야 정확함*
          if (updatedPosts.length >= totalCount) {
              setHasMore(false);
          }
          return updatedPosts;
      });
      
      setPageKey(prevKey => prevKey + PAGE_SIZE); // 함수형 업데이트를 사용하여 최신 pageKey 보장
      
    } catch (error) {
      console.error("데이터 로딩 실패:", error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }
}, [pageKey, hasMore, isLoading]);





  useEffect(() => {
setPosts([]);
    setPageKey(0);
    setHasMore(true);
    
    processData()

  }, []);

    useEffect(() => {
    if (pageKey === 0 && hasMore) {
        fetchPosts();
    }
  }, []);


  //   const handleSaveHeightSettings = (min, max) => {
  //   setMinHeight(min.toString()); // API 요청을 위해 문자열로 저장
  //   setMaxHeight(max.toString());
  //   setIsModalOpen(false);
  //   // useEffect가 minHeight/maxHeight 변경을 감지하고 데이터를 초기화 후 재로딩함.
  // };


    if (!dailylooksArray) {
    return <div style={{

          display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '250px',
    }}>


      <span style={{    marginBottom: '30px',
    fontSize: '12pt'}}>불러오는 중..</span>

      <img
                              src={'loading_logo.jpg'}

                              style={{
                                width: '50px',
                                marginRight: '10px'
                                // height: '44px',
                                // borderRadius: '50%',
                                // objectFit: 'cover',
                                // marginRight: '12px',
                              }}
                            />
      

      
      </div>;
  }

 return (
    <div style={styles.mobileContainer}>
    <ImagePopup 
                isOpen={isPopupOpen} 
                onClose={handleClosePopup} 

                
            />
            <LoginRequiredModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />
      {/* 1. 헤더 영역 */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
          
          {/* 알림 및 검색 아이콘 그룹 (좌/우 정렬) */}


          {/* 로고 (중앙 정렬) */}
          <img 
            src="/modii-logo.png"
            alt="modii-logo" 
            style={styles.logo}
          />
          
          <div style={styles.iconWrapper}>
            <MdOutlineNotifications size="24" color="#000000ff" style={styles.iconStyle} onClick={() => goToAlert()} />
            <MdOutlineCameraAlt size="24" color="#000000ff" style={styles.iconStyle} onClick={() => setIsPopupOpen(true)}  />
          </div>
        </div>

        {/* 구분선 */}
        <div style={styles.divider} />
      </header>
      
      <div style={{padding : '0 15px'}}>
      {/* 2. 주간 모디 정보 섹션 */}
      <section style={styles.infoSection}>
        
        {/* '주간 모디' 타이틀 및 툴팁 */}
        <div style={styles.titleGroup}>
          <a style={styles.titleText}>주간 모디</a>
          
          <a style={styles.infoIcon} data-tooltip-id="component-tooltip">ⓘ</a>
          <Tooltip id="component-tooltip" place="bottom" style={{zIndex: 100}}>
            <div style={{ padding: '5px' }}>
              <h4>주간모디에 선정되면.</h4>
              <span>닉네임 옆에 '</span>
              <img src="/badge.png" alt="뱃지" style={{ width: '25px', verticalAlign: 'middle' }}/>
              <span>'뱃지가 생겨요!</span>
            </div>
          </Tooltip>
        </div>
        
        {/* 임시 박스 (원래 코드의 70px 박스) */}
        <button 
      onClick={() => {

        const savedToken = localStorage.getItem('user');
            const storedUserObject = JSON.parse(savedToken);
            if(storedUserObject.username == 'temp'){
                        setShowLoginModal(true);

            }else{
                        navigate('/vote')
            }
        
        
          }

      }
      style={{
        // 1. 외관 및 색상
        backgroundColor: '#FF3640', // 사진 속 빨간색 (또는 #e74c3c와 유사)
        borderRadius: '8px',       // 매우 둥근 모서리
        padding: '6px 8px',        // 상하좌우 여백
        border: 'none',             // 테두리 제거
        cursor: 'pointer',

        // 2. 내용 정렬 (아이콘 + 텍스트)
        display: 'flex',
        alignItems: 'center',       // 수직 중앙 정렬
        justifyContent: 'center',   // 수평 중앙 정렬 (내부 요소 정렬)
        
        // 3. 텍스트 스타일
        color: 'white',
        fontSize: '10px',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',       // 줄바꿈 방지
        marginTop: '100px'
      }}
    >
      {/* 연필 아이콘 */}
      <FaPoll 
        size={12} 
        color="white" 
        style={{ marginRight: '6px' }} // 아이콘과 텍스트 사이 간격
      />
      
      {/* 텍스트 */}
      <span>투표하기</span>
    </button>
      </section>

      {/* 3. 베스트 타이틀 */}
      <p style={styles.bestTitle}>베스트 데일리룩에 투표해 보세요  👍</p>

      {/* 4. 데일리룩 이미지 */}
      <div style={styles.dailylooksGrid}>
        <div style={styles.imageCardWrapper}>
              <img 
                  src={dailylooksArray[0].thumbnail} 
                  alt="여성 데일리룩" 
                  style={styles.dailylookImage} 
                  onClick={() => goToPostDetail(dailylooksArray[0].id, 'w')}
              />
              {/* ⭐️ 오버레이 뱃지 */}
              <GenderBadge gender={dailylooksArray[0].user?.gender} rank={1} />
          </div>

          {/* ⭐️ 두 번째 아이템 (남성/오른쪽) */}
          <div style={styles.imageCardWrapper}>
              <img 
                  src={dailylooksArray[1].thumbnail} 
                  alt="남성 데일리룩" 
                  style={styles.dailylookImage} 
                  onClick={() => goToPostDetail(dailylooksArray[1].id, 'w')}
              />
              {/* ⭐️ 오버레이 뱃지 */}
              <GenderBadge gender={dailylooksArray[1].user?.gender} rank={1} />
          </div>
      </div>


                  {/* 8. 데일리룩 검색 */}
      <div>

        <br/>
        
        <a style={styles.titleText}>데일리룩 검색</a>


      <div style={styles.searchContainer}>
        <input
          type="text"
          placeholder="검색어를 입력하세요..."
          value={searchTerm}
          onChange={handleChange}
          onKeyDown={handleKeyDown} // Enter 키 이벤트 처리
          style={styles.inputField}
        />
        {/* onClick={handleSearch}  */}
        <button   onClick={() => goToSearch(searchTerm, '')} style={styles.searchButton}>
          <FaSearch size={20} color="#333"  />
        </button>
      </div>

              {keywordsArray.length > 0 && (
          <div>
                {Array.isArray(keywordsArray) && keywordsArray.map((keywords, index) => (
                          // 이미지 배너를 클릭 가능하게 <a> 태그로 감쌈

                              <StyleTag text={'#'+keywords} isActive={true} onClick={() => goToSearch(keywords, '')} />

                        ))}
                        </div>
                      )
        }


      </div>

        {/* 5. 홈배너 슬라이더 */}
        <div style={{ width: '100%', margin: '10pt auto' }}>
          {homebannerArray.length > 0 && (
            <div style={styles.sliderContainer}>
              <Slider {...bannerSettings}>
                {Array.isArray(homebannerArray) && homebannerArray.map((banner, index) => (
                  // 이미지 배너를 클릭 가능하게 <a> 태그로 감쌈
                  <div key={index}>
                      {/* <a href={banner.url || '#'} style={styles.bannerLink}> */}
                        {
                          homebannerArray[index].type == 'custom_url'?
                          <img 
                          onClick={() => window.open(homebannerArray[index].url, '_blank')}
                            src={homebannerArray[index].image} 
                            alt={`배너 ${index + 1}`} 
                            style={styles.bannerImage} 
                          />
                          :homebannerArray[index].type == "star_apply"?

                          <img 
                          onClick={() => navigate('event')}
                            src={homebannerArray[index].image} 
                            alt={`배너 ${index + 1}`} 
                            style={styles.bannerImage} 
                          />:homebannerArray[index].type == "estimation"?
                          <img 
                          onClick={() => navigate('rating')}
                            src={homebannerArray[index].image} 
                            alt={`배너 ${index + 1}`} 
                            style={styles.bannerImage} 
                          />:
                          <img 
                          onClick={() => setIsPopupOpen(true)}
                            src={homebannerArray[index].image} 
                            alt={`배너 ${index + 1}`} 
                            style={styles.bannerImage} 
                          />

                        }
                      {/* </a> */}
                  </div>
                ))}
              </Slider>
            </div>
        )}
      
      </div>





        {/* 9. 무드 선택 텍스트*/}
          <div style={{textAlign:'left'}}>
          
                  <br/>
                  
                  <a style={styles.titleText}>인기 코디</a>

                  <p style={styles.bestTitle}>유저에게 주목받는 스타일이에요 ✨</p>


                  <InfiniteScroll
              dataLength={posts.length} // 현재 로드된 항목 수
              next={fetchPosts}         // 스크롤이 끝에 도달하면 호출할 함수
              hasMore={hasMore}  
              scrollThreshold="60%"        // 더 불러올 데이터가 있는지 여부
              loader={<h4 style={{ textAlign: 'center' }}>로딩 중...</h4>}
              endMessage={<p style={{ textAlign: 'center' }}><b>모든 결과를 불러왔습니다.</b></p>}
              //scrollableTarget="scrollableDiv" // 스크롤바가 있는 DOM 요소의 ID (없다면 window)
            >
              <div style={styles.postsGrid}>

                {Array.isArray(posts) && posts.map((post, index) => (
                  <div key={index} style={styles.postItem}>

                    <img src={post.thumbnail} alt={post.keyword} style={styles.postImage}
                                onClick={() => goToPostDetail(post.id, 'd')}
                    
                    />
                    {post.more_images.length > 1?
                    <img src="/more.png" style={{ width: '25px', verticalAlign: 'middle',position:'absolute',top:"5px",right:'5px' }}/> : <></>
                      }
                    <p>{post.description}</p>
                  </div>
                ))}
              </div>
            </InfiniteScroll>
       


        </div> 
        </div>

       <BottomNavBar 
                activePath={currentPath} // 현재 경로를 전달하여 활성 상태 지정
                items={MAIN_NAV_ITEMS}   // 아이템 목록을 전달
                onItemClick={handleNavigation} // 클릭 시 실행할 함수 전달
            />

    </div>
  );

  function GenderBadge({ gender, rank }) {
    // 성별에 따른 텍스트 결정
    const genderText = gender === 'W' ? '여성' : '남성';
    const backgroundColor = gender === 'W' ? '#000000a8' : '#000000a8'; // 이미지와 같이 어두운 배경 사용

    return (
        <div style={{ ...badgeStyles.badgeContainer, backgroundColor }}>
            <span style={badgeStyles.rank}>{rank}</span>
            <span style={badgeStyles.gender}>{genderText}</span>
        </div>
    );
}
}

const badgeStyles = {
    badgeContainer: {
        position: 'absolute', // ⭐️ 필수: 부모(imageCardWrapper) 기준으로 위치 지정
        top: 5,
        left: 5,
        backgroundColor: '#4A4A4A', // 진한 회색 배경
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        padding: '6px 10px',
        borderRadius: '8px', // 오른쪽 하단 모서리만 둥글게
        fontSize: '10px',
        fontWeight: 'bold',
        zIndex: 10, // 이미지 위에 표시
        flexDirection: 'column'
    },
    rank: {
       
        fontSize: '18px',
    },
    gender: {
        //
    }
};

// 스타일 객체 정의 (반응형 모바일에 적합하게)
const styles = {


    // ⭐️ 필수: 이미지와 뱃지를 감싸는 Wrapper (relative 기준점 제공)
    imageCardWrapper: {
        position: 'relative', // 👈 핵심
        //width: '49%', // dailylooksGrid의 gap과 맞춰 너비 조정
        borderRadius: '8px',
        overflow: 'hidden',
    },


  navBar: {
        // 1. 위치 고정
        position: 'fixed', 
        bottom: 0,
        left: 0,
        
        // 2. 크기 및 외관 설정
        width: '100%',
        maxWidth: '420px', // 모바일 최대 너비에 맞춤
        height: '60px', // 내비게이션 바 높이
        backgroundColor: '#fff',
        borderTop: '1px solid #ddd', // 상단 구분선
        boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.05)',
        zIndex: 100, // 다른 요소 위에 표시되도록 z-index 설정

        // 3. Flexbox를 사용한 아이템 정렬
        display: 'flex',
        justifyContent: 'space-around', // 아이템들을 균일하게 배치
        alignItems: 'center',
    },
    navItem: {
        display: 'flex',
        flexDirection: 'column', // 아이콘과 텍스트를 세로로 쌓기
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1, // 각 아이템이 사용 가능한 공간을 동일하게 차지
        padding: '5px 0',
        cursor: 'pointer',
    },
    navText: {
        fontSize: '10px',
        marginTop: '3px',
        fontWeight: 'bold',
    },

  feedContainer: {
        maxWidth: '420px',
        margin: '0 auto',
        padding: '10px 15px',
        
    },
    controlPanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
    },
    keywordInput: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #ddd',
    },
    filterButton: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #007bff',
        backgroundColor: '#fff',
        color: '#007bff',
        cursor: 'pointer',
    },
    resultTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '15px',
    },
    postsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr', 
        gap: '1px',
    },
    postItem: {
        //border: '1px solid #eee',
        //borderRadius: '8px',
        overflow: 'hidden',
        height: '160px',
        cursor:'pointer',
        position:'relative'
    },
    postImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
  mobileContainer: {
    maxWidth: '420px', // 일반적인 모바일 최대 너비
    margin: '0 auto',  // 중앙 정렬 (웹에서 볼 경우 대비)
    // padding: '0 5vw', // 좌우 패딩을 뷰포트 너비 기준으로 설정하여 반응성 확보
  },
  
  header: {
    paddingTop: '20px',
    position:'fixed',
    top:'0',
    width:'100%',
    maxWidth:'420px',
    backgroundColor:'white',
    zIndex:'20'
  },
  
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between', // 요소들을 양 끝으로 분산
    alignItems: 'center',
    paddingRight:'15px',
        paddingLeft:'15px'
  },
  
  logo: {
    height: '21px',
    // 로고는 중앙에 위치하도록 flexbox가 처리
  },
  
  iconWrapper: {
    // 아이콘 그룹을 위한 컨테이너 (각 아이콘에 개별 마진 대신 flex 사용)
 display: 'flex',
 gap:'15px'
  },
  
  iconStyle: {
    // 아이콘 크기는 이미 24px로 설정됨
  },
  
  divider: {
    height: '1px', 
    // backgroundColor: '#d4d4d4ff', 
    marginTop: '20px', // 수직 여백을 뷰포트 높이 기준으로 설정
  },

  infoSection: {
    display: 'flex',
    justifyContent: 'space-between', // 주간모디 그룹과 임시 박스를 양 끝으로 분산
    alignItems: 'center',
    marginBottom: '5px',
    //marginTop:'100px'
  },
  
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px', // 요소 사이의 간격
    marginTop: '100px'
  },
  
  titleText: {
    color: '#000000ff',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  
  infoIcon: {
    color: '#000000ff',
    cursor: 'pointer',
  },

  placeholderBox: {
    width: '70px',
    height: '20px',
    backgroundColor: 'rgb(0, 0, 0)',
    // flexbox가 자동으로 오른쪽 끝에 배치
  },
  
  bestTitle: {
    color: '#ff0000ff',
    fontSize: 'small',

    margin: '5px 0',
  },

  dailylooksGrid: {
    display: 'flex',
    justifyContent: 'space-between', // 두 이미지를 양 끝으로 분산
    gap: '3px', // 이미지 사이 간격
    //marginTop: '10px',
  },

  dailylookImage: {
    width: "100%", // 컨테이너 너비의 49%를 차지 (간격 포함 100% 미만)
    height: '230px',
        borderRadius: '8px',
    objectFit: 'cover',

  },

  sliderContainer: {
      // 슬라이더 자체의 좌우 패딩을 모바일 컨테이너와 동일하게 맞추려면 padding: 0 이 필요할 수 있음
      // 여기서는 모바일 컨테이너의 패딩을 따름
      marginBottom: '20px',
      // slick-dots 커스터마이징을 위해 추가 CSS 필요
  },
  bannerLink: {
      display: 'block',
  },
  bannerImage: {
      width: '100%',
      height: '90px',
      borderRadius: '10px', // 이미지와 같은 모서리 둥글게 처리
      display: 'block', // 인라인 요소의 기본 여백 제거
  },

  defaultTag: {
    // 배경 및 텍스트 색상
    backgroundColor: '#ffffffff', 

    
    // 모서리 둥글게
    borderRadius: '10px', 
    
    // 내부 여백 (클릭 영역 확보)
    padding: '4px 8px', 
    
    // 글꼴 설정 (폰트에 따라 다를 수 있음)
    fontSize: '13px', 
    fontWeight: 'normal',
    
    // 기타 설정
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    
    // 옆 요소와의 간격
    marginRight: '10px', 
  },
  
  // 텍스트 밑줄 스타일 (이미지와 가장 유사하게 구현하기 위해 span에 적용)
  textUnderline: {
    // 텍스트와 거의 같은 색상의 얇은 밑줄 효과
    borderBottom: '1px solid #ffffff', 
    paddingBottom: '2px', // 텍스트와 밑줄 사이의 간격
  },
  
  // 선택되었을 때의 스타일 (필요하다면)
  // activeTag: {
  //   // defaultTag 스타일을 복사하고 필요한 부분만 변경 (예: 빨간색 테두리)
  //   ...this.defaultTag,
  //   // 예시: 선택 시 배경색 변경
  //   backgroundColor: '#111111', 
  // }
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px', // 컴포넌트의 최대 너비를 제한하여 모바일에 적합하게 조정
    margin: '10px auto',
    border: '1px solid #ccc',
    borderRadius: '25px', // 둥근 모서리
    overflow: 'hidden', // 버튼과 인풋필드를 묶음
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  inputField: {
    flexGrow: 1, // 입력 필드가 남은 공간을 모두 차지하도록
    padding: '10px 15px',
    border: 'none',
    outline: 'none',
    fontSize: '16px',
    lineHeight: 1.5,
  },
  searchButton: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '10px 15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
  },

  dropdownContainer: {
    position: 'relative',
    display: 'inline-block', // 너비를 내용물에 맞춥니다.
    
  },
  dropdownButton: {
    padding: '5px 5px',
    border: '1px solid #ff0000ff',
    borderRadius: '5px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color : 'red'

  },
  arrow: {
    marginLeft: '10px',
    fontSize: '10px',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '100%', // 버튼 바로 아래에 배치
    left: 0,
    zIndex: 1000,
    minWidth: '100%',
    padding: 0,
    margin: '4px 0 0 0',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    listStyle: 'none', // 리스트 마커 제거
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  menuItem: {
    padding: '10px 20px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0', // 마우스 오버 시 배경색 변경 (인라인 스타일에서는 직접 구현 어려움)
    },
  },

    modalHeader: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '5px',
    textAlign: 'center',
  },
  modalSubtitle: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '20px',
    textAlign: 'center',
  },
  tagsGrid: {
    display: 'flex',
    flexWrap: 'wrap', // 태그를 다음 줄로 넘김
    gap: '8px',       // 태그 간의 간격
    maxHeight: '400px', // 스크롤이 필요할 경우 최대 높이 지정
    overflowY: 'auto',
    padding: '10px 0',
  },
  tagBase: {
    padding: '8px 15px',
    borderRadius: '20px', // 타원형 모양을 위한 큰 BorderRadius
    border: '1px solid transparent',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.2s, color 0.2s',
  },
  tagDefault: {
    backgroundColor: '#f0f0f0', // 비활성화된 태그 배경색 (연한 분홍색과 유사하게)
    color: '#333',
  },
  tagSelected: {
    backgroundColor: '#e64e4e', // 선택된 태그 배경색 (이미지의 빨간색)
    color: 'white',
    fontWeight: 'bold',
  },
  confirmButton: {
    width: '100%',
    padding: '15px 0',
    marginTop: '20px',
    backgroundColor: '#e64e4e', // 이미지와 같은 빨간색
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  }
  


}

const dropdownStyles = {
  container: {
    marginBottom: '15px',
  },
  label: {
    display: 'block',
    marginBottom: '5px',
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#555',
  },
  select: {
    width: '100%',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    fontSize: '16px',
    appearance: 'none', // 브라우저 기본 드롭다운 스타일 제거
  }
};

const modalStyles = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  content: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    width: '90%',
    maxWidth: '350px',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
  },
  buttonGroup: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  closeButton: {
    padding: '10px 15px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#eee',
    cursor: 'pointer',
  },
  saveButton: {
    padding: '10px 15px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#007bff',
    color: 'white',
    cursor: 'pointer',
  },
};

const mainStyles = {
    openButton: {
        padding: '10px 20px',
        border: 'none',
        borderRadius: '5px',
        backgroundColor: '#f0f0f0',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '16px',
    }
}

export default Home;
